import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { iDeath } from '@app/features/obituaries/death.interface';
import { ObituaryApi } from '@app/features/obituaries/obituary.api';
import { ObituaryService } from '@app/features/obituaries/obituary.service';
import { NavigationService } from '@app/services/navigation/navigation.service';
import { SharedModule } from '@app/shared/shared.module';
import { TabViewModule } from 'primeng/tabview';

@Component({
	selector: 'app-home-obituary',
	standalone: true,
	encapsulation: ViewEncapsulation.None,
	imports: [
		SharedModule,
		TabViewModule,
	],
	providers: [
		ObituaryService,
		ObituaryApi,
	],
	templateUrl: './home-obituary.component.html',
	styleUrl: './home-obituary.component.scss'
})
export class HomeObituaryComponent implements OnInit {
	private listSize:number = 5;
	public loading:boolean = true;
	public list: iDeath[] = [];

	constructor (
		public nav: NavigationService,
		private service: ObituaryService,
	) { }

	ngOnInit(): void {
		this.loadDeaths();
	}

	private loadDeaths() {
		this.loading = true;
		this.service.getDeaths()
			.subscribe({
				next: (rs) => {
					const data: iDeath[] = rs.list;
					this.list = data.slice(0,this.listSize);
					this.loading = false;
				},
				error: err => {
					console.error(err);
					this.loading = false;
				}
			})
	}

	public goDead(dead: iDeath) {
		this.nav.goDeathView(dead);
	}

}
